import React, { Component } from 'react';
import { Avatar, Modal } from 'antd';

import './Picture.css';
import Api from '../../../services/Api';

class Picture extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        visible: false,
        base64: null,
      },
    };
  }

  componentDidMount() {
    const that = this;
    Api.get(`/file`, { key: this.props.picture.key })
      .then(blob => {
        const reader = new FileReader();
        reader.onload = function() {
          that.setState({ base64: reader.result });
        };
        reader.readAsDataURL(blob);
      })
      .catch(error => console.log(error));
  }
  handleClick = e => {
    this.setState({ modal: { visible: true, src: e.target.src } });
  };

  handleClose = e => {
    this.setState({ modal: { visible: false, src: undefined } });
  };

  handleDelete = key => {
    const { picture } = this.props;
    this.props.onDelete(picture);
  };

  render() {
    const { allowDelete, picture } = this.props;
    const { base64 } = this.state;

    return (
      <div>
        <Avatar onClick={this.handleClick} src={base64} size={75} shape="square" />
        {allowDelete && (
          <button type="button" className="photos-gallery__delete txt-error">
            <span className="sr-only">Delete</span>
            <svg
              onClick={key => this.handleDelete(picture.key)}
              className="bmw-icon bmw-icon-md"
              aria-hidden="true"
            >
              <use xlinkHref="#icon-cross-circle" />
            </svg>
          </button>
        )}
        <Modal
          visible={this.state.modal.visible}
          onCancel={this.handleClose}
          footer={null}
        >
          <br />
          <img alt="" src={this.state.modal.src} />
        </Modal>
      </div>
    );
  }
}

export default Picture;



// WEBPACK FOOTER //
// ./src/components/interventiondetail/picture/Picture.js